import Icon from '../components/Icon.vue'

Icon.register({"modx":{"width":1792,"height":1792,"paths":[{"d":"M1427 709l-614-386 92-151h855zM405 974l-184-116v-858l1183 743zM1424 839l147 95v858l-532-335zM1387 818l-500 802h-855l356-571z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/modx.js
// module id = 752
// module chunks = 0